import { useSelector } from 'react-redux';
import { selectClaimsLoading } from '../../features/claims/claimSlice';
import { selectCurrentUser } from '../../features/auth/authSlice';
import { selectClaimDocuments } from '../../features/documents/documentSlice';
import DocumentList from '../documents/DocumentList';
import OmCard from '../ui/OmCard';
import OmButton from '../ui/OmButton';
import OmCircularProgress from '../ui/OmCircularProgress';

const DocumentsSection = ({ claim, userRoles, documentListKey, onDocumentUpload }) => {
  const hasUploadRole = userRoles.includes('HR') || userRoles.includes('Broker') || userRoles.includes('CRM') || userRoles.includes('Admin');
  const isClaimLoading = useSelector(selectClaimsLoading);
  const currentUser = useSelector(selectCurrentUser);
  // DEV FIX: use Redux state for documents to avoid stale claim.documents check
  const claimDocuments = useSelector(selectClaimDocuments);
  
  // Check if claim status allows document uploads
  const finalizedStatuses = ['APPROVED', 'REJECTED', 'PAID', 'CLOSED'];
  const isClaimFinalized = finalizedStatuses.includes(claim?.status);
  const canUpload = hasUploadRole && !isClaimFinalized;

  return (
    <OmCard className="bg-crystal-white shadow-soft border border-steel/20 rounded-lg overflow-hidden transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 hover:border-fresh-leaf/30 focus-within:ring-2 focus-within:ring-fresh-leaf/25 focus-within:border-fresh-leaf/40">
      <div className="px-6 sm:px-8 pt-6 sm:pt-8 pb-4 sm:pb-6 border-b border-steel/15 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex-1">
          <h3 className="text-xl sm:text-2xl font-semibold text-graphite mb-3">Supporting Documents</h3>
          <p className="text-sm sm:text-base text-steel">Files and attachments for this claim</p>
        </div>
        
        {/* Upload Document button removed - functionality hidden from UI */}
      </div>
      
      <div className="p-6 sm:p-8">
        {isClaimLoading ? (
          <div className="text-center py-16 sm:py-20">
            <div className="mb-6 flex justify-center">
              <OmCircularProgress
                indeterminate={true}
                size="large"
              />
            </div>
            <div className="space-y-2 animate-fade-in">
              <p className="text-sm sm:text-base text-graphite font-medium">Loading documents...</p>
              <p className="text-xs sm:text-sm text-steel">Please wait while we fetch your files</p>
            </div>
          </div>
        ) : (!claimDocuments || claimDocuments.length === 0) ? (
          <div className="text-center py-16 sm:py-20 border-2 border-dashed border-steel/40 rounded-lg bg-silver-mist/30">
            <svg className="mx-auto h-16 w-16 sm:h-20 sm:w-20 text-steel/40 mb-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" 
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <h3 className="text-lg sm:text-xl font-semibold text-graphite mb-3">No documents</h3>
            <p className="text-sm sm:text-base text-steel mb-8 sm:mb-10 max-w-sm mx-auto leading-relaxed">
              There are no supporting documents attached to this claim.
            </p>
            
            {/* Upload Your First Document button removed - functionality hidden from UI */}
          </div>
        ) : (
          <DocumentList 
            key={documentListKey}
            claimId={claim.id}
            canDelete={
              !!currentUser && (
                claim?.submittedById === currentUser?.userId ||
                claim?.submittedBy?.id === currentUser?.userId
              )
            }
            canDownload={true}
          />
        )}
      </div>
    </OmCard>
  );
};

export default DocumentsSection;
